<template>
  <div class="foundation-info">
    <div class="top-img">
      <img :src="imgSrc" alt="" width="100%">
    </div>
    <!-- <div class="top-tabs">
      <el-tabs v-model="clickMenuUrl" @tab-click="handleClick">
        <el-tab-pane v-for="item in menuList" :label="item.name" :name="item.href" :key="item.id"></el-tab-pane>
      </el-tabs>
    </div> -->
    <div class="top-tabs" :class="{'top-tabs-mobile' : isMobile == 'mobile'}">
      <div :class="$i18n.locale=='zh'?'tabs-list':'tabs-list-en'">
        <div class="tabs-item" :class="item.href == clickMenuUrl?'tabs-item-click':''" @click="handleClick(item.href)" v-for="item in menuList" :key="item.id">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div :style="{padding: screenWidth<=540?'2rem 5%':'2rem 0%'}" v-if="isMobile == 'pc'">
      <router-view></router-view>
    </div>
    <div v-if="isMobile == 'mobile'">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import i18n from '@/i18n';
import { listBannerByModuleId } from '@/api/index'
export default {
  computed: {
    ...mapState(['screenWidth', 'clickMenuUrl']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    },
    menuList() {
      return [
        {
          name: this.$t('FoundationIntroduction'),
          id: '1',
          href: '/organizationalProfile/foundationIntroduction'
        },
        {
          name: this.$t('FoundingDirectorUnit'),
          id: '2',
          href: '/organizationalProfile/foundingDirectorUnit'
        },
        {
          name: this.$t('Council'),
          id: '3',
          href: '/organizationalProfile/council'
        },
        {
          name: this.$t('OrganizationStructure'),
          id: '4',
          href: '/organizationalProfile/organizationStructure'
        }
      ]
    }
  },
  data() {
    return {
      imgSrc: '',
    };
  },
  mounted() {
    this.listBannerByModuleIds()
    console.log("i18n",this.$i18n.locale);
    
  },
  methods: {
    listBannerByModuleIds() {
      const formData = new FormData();
      // 添加字符串类型的数据
      formData.append("moduleId", 3);
      listBannerByModuleId(formData).then(res => {
        if (res.data && res.data != null) {
          this.imgSrc = res.data[0].imgUrl;
        }
      })
    },
    handleClick(url) {
      // console.log('tab', tab);
      // localStorage.setItem('clickorganizationalProfileMenuId', tab.name);
      // this.$router.push(tab.name);
      this.$router.push(url);
    }
  }
};
</script>

<style lang="less" scoped>
.foundation-info {
  width: 100%;
  overflow: hidden;
  padding-bottom: 2rem;
  background-color: #fff;
  .top-img {
    width: 100%;
  }
}

:deep(.el-tabs__item.is-active) {
  color: #c8933c;
}
::v-deep .el-tabs__nav-wrap::after,
.el-tabs__nav-wrap::after {
  background: none;
}
::v-deep .el-tabs__active-bar {
  background-color: #c8933c;
}
::v-deep .el-tabs__header {
  margin: 0;
}
.top-tabs {
  padding: 1rem 2rem 1rem 0;
  width: 100%;
  box-sizing: border-box;
  background-color: #ebedef;
  overflow: auto;
}
.top-tabs-mobile{
  padding: 1rem 2rem 1rem 0;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff!important;
  overflow: auto;
  .tabs-item-click{
    color: #fff!important;
  }
  .tabs-item{
    color: #000;
  }
}
.tabs-item {
  flex: 1;
  height: 2.6rem;
  text-align: center;
  line-height: 2.6rem;
  padding: 0 1rem;
  font-size: 1.3rem;
  border-radius: 1.5rem;
  background-color: #f3f3f3;
  color: #6a6a6a;
  float: left;
  margin-left: 2rem;
}
.tabs-list{
  width: 40rem;
}
.tabs-list-en{
  width: 63rem;
}
.tabs-item-click {
  background-color: #B8210F;
  color: white;
}
</style>